import * as React from 'react';
import { InlineText1, Paragraph2 } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface IConstructionProgressHeaderProps {
  newbuildingName: string;
  date: string | undefined;
  favorite: React.ReactNode;
  call: React.ReactNode;
}

export function ConstructionProgressHeader({
  newbuildingName,
  date,
  favorite,
  call,
}: IConstructionProgressHeaderProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['main']}>
        <Paragraph2 color="white_60">{newbuildingName}</Paragraph2>
        <InlineText1 color="white_100" fontWeight="bold">
          {date}
        </InlineText1>
      </div>
      <div className={styles['aside']}>
        <div className={styles['call']}>{call}</div>
        {favorite}
      </div>
    </div>
  );
}
